import { http } from "Utils/http";
import { Form, Tabs, Tab, Row, Col, Card,Dropdown,Button, Stack,Modal,CloseButton } from "react-bootstrap";
import { useState, useEffect} from "react";
import {useLocation } from 'react-router-dom';
import {store} from 'Store';
import {setGlobalErrorStatus, setGlobalSuccessStatus} from 'Components/StatusHandling'
import { useDispatch } from "react-redux"
import {GetTableauUserCheckboxInputData,  GetTableauUserSelectInputData, GetTableauUserRadioInputData } from 'Containers/Private/Tableau/TableauUserFields';
import {FormInputDisplay} from 'Components/Forms/FormInputDisplay.js';
import { useNavigate} from 'react-router-dom';
import { ERROR_MESSAGES } from "Utils/constants";
import { TextButton } from "Components/Button";
import { formatDocDate, getDocumentDownloadCall, getDocumentPublicInfo, getVarValue } from "Utils/utilityFunctions";
import { ICONS } from "Utils/icons";
import { Icon0Square } from "react-bootstrap-icons";

const ArticleCard = ({groupId, image, imageAlt, cardTitle, text, isVideo, action, bg, classes, imgVariant,imgHeight}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let location = useLocation();
    var passedData = location.state;
    //console.log("PASSED DATA");
    //console.log(passedData);
    
    const [isLoading, setIsLoading] = useState(true);
    const [filename, setFilename] = useState(null);
    const [link, setLink] = useState(null);

    const [date, setDate] = useState(null);
    const [title, setTitle] = useState(cardTitle);

    useEffect(() => {
        if(groupId != null){
            //loadFormData();
            loadDocInfo();
        }
        else{
            
        }
        
    }, []);

    
    const loadDocInfo = () => {
        setIsLoading(true);
        getDocumentPublicInfo(groupId).then(res => {
            //console.log(res);
            setDate(res.data.documentTagInfo.postedOn);
            setTitle(res.data.documentTagInfo.docDisplayName);
            setIsLoading(false);

        }).catch((error) => {
            //console.log("Error caught while loading data: " + error);

        });
    }
   

    const loadFormData = () => {
        
        getDocumentDownloadCall(groupId).then((res) => {
            //console.log("getFormData ", res);
            //console.log(res);
            //console.log(res.headers);
            //console.log(res.headers['content-disposition']);
            // get filename from the res content-disposition
            //console.log(res.headers["content-disposition"]?.split('filename='));
            //const filename = res.headers["content-disposition"]?.split('filename=')[1].split(';')[0].replace(/^"(.*)"$/, '$1');
            const filename = res.headers["content-disposition"]?.split('filename=')[1];
            //console.log(filename);
            let url = window.URL.createObjectURL(res.data);
            let a = document.createElement('a');
            a.href = url;
            setLink(url);
            setFilename(filename);
            a.text=res.headers["content-disposition"]?.split('filename=')[1];
            a.download = res.headers["content-disposition"]?.split('filename=')[1];
            
            //document.body.appendChild(a); // append the element to the dom
            return {
                href:url,
                filename: filename,
            };

        }).catch((error) => {
            //console.log("Error caught while loading data: " + error);

            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        
    };

    

    return (
        isLoading==false 
        ?
            <Card variant="article-card" bg={bg != null ? bg : ""} className={classes!=null ? " article-card h-100 " + classes: "article-card h-100"} as={Button} role="button" onClick={(e)=>{
                //console.log(e);
                action();
            }}>
                <div className={isVideo != null && isVideo == true ? "card-con video" : "card-con"}>
                    <Card.Img height={imgHeight} variant={imgVariant!=null ? imgVariant : "top"} src={image} alt={imageAlt}></Card.Img>
                </div>
                <Card.Body className="p-4">
                    <Card.Title ><span className="me-1">{title}</span><ICONS.download/></Card.Title>
                    <Card.Text>{getVarValue(text)}</Card.Text>
                    <Card.Footer className="p-0 mt-auto">{date!=null ? formatDocDate(date) : null}</Card.Footer>
                </Card.Body>
                
            </Card>
        : null    
    )
}

export default ArticleCard;
